// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ActiveUniversalButtons_loadingContainer__1rqTS"};